import { StatusOption } from '../../utils'

export enum StaffApplicationType {
  PROFESSOR_LANGUAGE = 'PROFESSOR_LANGUAGE',
  PROFESSOR_REFERENT = 'PROFESSOR_REFERENT',
  ANIMATOR = 'ANIMATOR',
  DIRECTOR = 'DIRECTOR',
  AAT = 'AAT'
}

export const staffApplicationTypeMapping: Record<StaffApplicationType, StatusOption> = {
  PROFESSOR_LANGUAGE: {
    label: 'Professeur de langue',
    variant: 'secondaryDarkBlue'
  },
  PROFESSOR_REFERENT: {
    label: 'Professeur référent',
    variant: 'blue'
  },
  ANIMATOR: {
    label: 'Animateur',
    variant: 'yellow'
  },
  AAT: {
    label: 'AAT',
    variant: 'success'
  },
  DIRECTOR: {
    label: 'Directeur',
    variant: 'violet'
  }
}
